/** @module SiteAdmin/PasswordMaxLengthController */
define([
	"dojo/_base/declare",
	"csi/heading/NumberController",
	"csi/locale"
], function(declare, NumberController, locale) {

	return declare(NumberController, {
		/** 
		 * @override
		 * Make sure the min length less than or equal to the max length
		 */
		onValidate() {
			var maxLength = this.newValue;
			if (maxLength > 80) {
				throw new Error(locale.resource("Validation_PasswordMaxLength"));
			}

			var minLength = this.getNode().PasswordMinLength;
			if (minLength > maxLength) {
				throw new Error(locale.resource("Validation_PasswordLength"));
			}
		}
	});
});